import "../polyfills/is-nan";
import "../polyfills/for-each";

if ($("#insta-feed").length) {
  let configMutationInstafeed = {
    attributes: false,
    childList: true,
    characterData: false,
  };
  let instafeed = document.getElementById("insta-feed");
  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      createSliderHtml(instafeed);
    });
  });

  observer.observe(instafeed, configMutationInstafeed);
}

if ($("#insta-feed-product").length) {
  let instaFeedProduct = $("#insta-feed-product");
  createSliderHtml(instaFeedProduct);
}

function createSliderHtml(targetedElement) {
  if (!$(targetedElement).hasClass("cloned")) {
    const sliderInstagram = $(".js-slider-instagram");
    const images = $(targetedElement).find(".instafeed-container").find("img");
    const urls = $(targetedElement).find(".follow");

    let sliderHtml = "";

    if (images.length >= 2) {
      $(targetedElement).addClass("cloned");

      for (let index = 0; index < images.length; index++) {
        let imageSrc = images[index].dataset.src;
        let url = urls[index] ? urls[index].href : null;

        if (url) {
          sliderHtml += `
        <div class="slick-slide">
          <div style="margin: 0 4px">
            <div class="card-instagram">
                <a href="${url}" target="_blank" class="card__link" rel="noopener"></a>
            
                <img alt="instagram image" class="card__image lazyload" data-src="${imageSrc}" />
            </div>
          </div>
        </div>
				`;
        } else {
          sliderHtml += `
					<div class="slick-slide">
            <div style="margin: 10px">
              <div class="card-instagram">
                <img alt="instagram image" class="card__image lazyload" data-src="${imageSrc}" />
              </div>
            </div>
				  </div>
				`;
        }
      }

      if (sliderHtml !== "") {
        $(".js-section-instagram").removeClass("hidden");
        sliderInstagram.append(sliderHtml);

        $(".js-slider-instagram").slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          lazyLoad: "progressive",
          draggable: true,
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ],
          customPaging: function (slick, index) {
            return "";
          },
        });
      }
    }
  }
}
